import { Pipe, PipeTransform } from '@angular/core';
import { ContentContextType } from '@shared/enums/ContentContextType';
import { IAdvancedTemplateFooterModel } from '@shared/services/api/dashboard/advanced-templates-service/advanced-templates.model';
import { IFooterModel } from '@shared/services/api/dashboard/footers-service/footers.model';

@Pipe({
    name: 'filterFooterType'
})
export class FilterFooterTypePipe implements PipeTransform {
    transform(selectedFooters: IAdvancedTemplateFooterModel[], contextType: ContentContextType): any {
        const filteredFooters: IFooterModel[] = [];

        selectedFooters.forEach(selectedFooter => {
            if (selectedFooter.contentContextType === contextType) {
                filteredFooters.push(selectedFooter.footer);
            }
        });

        return filteredFooters;
    }
}
